import React from 'react';
import { Box, Container, Grid, Typography, Link, Divider } from '@mui/material';
import FacebookIcon from '@mui/icons-material/Facebook';
import TwitterIcon from '@mui/icons-material/Twitter';
import InstagramIcon from '@mui/icons-material/Instagram';
import { GridProps } from '../types/mui-types';

// Use a type assertion to work around TypeScript issues with Material UI Grid
const GridItem = Grid as React.ComponentType<GridProps>;

const Footer: React.FC = () => {
  return (
    <Box sx={{ bgcolor: '#f8f8f8', pt: 6, pb: 6, mt: 'auto' }}>
      <Container maxWidth="lg">
        <GridItem container spacing={4} sx={{ justifyContent: 'space-between' }}>
          <GridItem item xs={12} sm={4}>
            <Typography variant="h6" color="text.primary" gutterBottom>
              JUNKOUT
            </Typography>
            <Typography variant="body2" color="text.secondary">
              Professional junk removal services for residential and commercial properties.
              We make getting rid of unwanted items easy and eco-friendly.
            </Typography>
            <Box sx={{ mt: 2, display: 'flex', gap: 1 }}>
              <Link href="#" color="inherit">
                <FacebookIcon />
              </Link>
              <Link href="#" color="inherit">
                <TwitterIcon />
              </Link>
              <Link href="#" color="inherit">
                <InstagramIcon />
              </Link>
            </Box>
          </GridItem>
          
          <GridItem item xs={12} sm={4}>
            <Typography variant="h6" color="text.primary" gutterBottom>
              Quick Links
            </Typography>
            <Link href="/" color="inherit" display="block" sx={{ mb: 1 }}>
              Home
            </Link>
            <Link href="/services" color="inherit" display="block" sx={{ mb: 1 }}>
              Services
            </Link>
            <Link href="/pricing" color="inherit" display="block" sx={{ mb: 1 }}>
              Pricing
            </Link>
            <Link href="/how-it-works" color="inherit" display="block" sx={{ mb: 1 }}>
              How It Works
            </Link>
            <Link href="/about" color="inherit" display="block" sx={{ mb: 1 }}>
              About Us
            </Link>
          </GridItem>
          
          <GridItem item xs={12} sm={4}>
            <Typography variant="h6" color="text.primary" gutterBottom>
              Contact Us
            </Typography>
            <Typography variant="body2" color="text.secondary" sx={{ mb: 1 }}>
              123 Main Street, Anytown, USA
            </Typography>
            <Typography variant="body2" color="text.secondary" sx={{ mb: 1 }}>
              Email: info@junkout.com
            </Typography>
            <Typography variant="body2" color="text.secondary" sx={{ mb: 1 }}>
              Phone: (555) 123-4567
            </Typography>
            <Typography variant="body2" color="text.secondary" sx={{ mb: 1 }}>
              Hours: Mon-Sat: 8am-6pm
            </Typography>
          </GridItem>
        </GridItem>
        
        <Divider sx={{ mt: 3, mb: 3 }} />
        
        <Typography variant="body2" color="text.secondary" align="center">
          {'© '}
          {new Date().getFullYear()}
          {' JunkOut. All rights reserved.'}
        </Typography>
      </Container>
    </Box>
  );
};

export default Footer;
